// ----------------------------------------------------------------------
// <copyright file="Izenda.ProvisioningMapData.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Button = require('share/components/controls/Izenda.Button');
  var ProvisionMapDataStore = require('logic/Izenda.ProvisionMapDataStore');
  var uiState = require('logic/Izenda.UiState');
  var PROVISIONING_STATUS = require('logic/data/Izenda.AppGlobalConstants').PROVISIONING_STATUS;

  var POLLING_PROVISION_DATA_STATUS_INTERVAL = 60000;

  var ProvisioningMapData = function (props) {

    var loader = props.loader;
    var localization = this.props.localization;
    var canProvisioning = uiState.canProvisioning;

    return (
        <GridLayout className="u-bgWhite u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col cols={2}>
              <span className="text-bold u_controlHeight">{localization.getText('LICENSE_CHECKER_LABEL_IMPORT_MAP_DATA')}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={10}>
              <Button
                  disabled={!canProvisioning}
                  className="u_marginRight"
                  label={localization.getText('LICENSE_CHECKER_LABEL_PROVISION_MAP_DATA')}
                  onClick={importMapData}
              />
              <a><span className="icon-info-circled"/></a>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
    );

    function importMapData () {
      loader.startLoading();
      ProvisionMapDataStore.importMapData().finally(loader.endLoading.bind(loader));

      // Polling Provision status after provisioning map data, stop it when it get success or error
      var pollingProvisionStatus = setInterval(function () {
        ProvisionMapDataStore.getProvisioningStatus().then(function (result) {
          if (result !== PROVISIONING_STATUS.IMPORTING) {
            window.clearInterval(pollingProvisionStatus);
          }
        });
      }, POLLING_PROVISION_DATA_STATUS_INTERVAL)
    }
  };

  module.exports = connect()(ProvisioningMapData)

}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.ProvisioningMapData.jsx